export default [
  {
    path: '/app/site-menu',
    name: 'SiteMenus',
    component: () => import('@/views/Admin/Menus/Index.vue'),
    meta: {
      pageTitle: 'Site Menü',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_MENU',
      action: 'read',
    },
  },
  {
    path: '/app/site-menu/add',
    name: 'SiteMenuAdd',
    component: () => import('@/views/Admin/Menus/Add.vue'),
    meta: {
      pageTitle: 'Site Menü',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/site-menu',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_MENU',
      action: 'read',
    },
  },
  {
    path: '/app/site-menu/edit/:id',
    name: 'SiteMenuEdit',
    component: () => import('@/views/Admin/Menus/Edit.vue'),
    meta: {
      pageTitle: 'Site Menü',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/site-menu',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_SITE_MENU',
      action: 'read',
    },
  },
]
